import { classes } from 'html-classes';
import { useTranslation } from 'react-i18next';

import { KYCStatus } from '~/api/KYCStatus';
import { company } from '~/company/Company';
import { VERIFICATION } from '~/constants/verification';

import { cartStore, checkoutStore, userStore } from '~/stores';

import type { SubtotalInfoProps } from '../../../types';

import { CartCostItems } from '../../CartCostItems';

import styles from './SubtotalInfo.module.scss';

const SubtotalInfo = ({
  isWarehouseClosed,
  isLoading,
  onCheckout,
  onNavigateToCheckout,
  stickyWrapperStyles,
  subtotalWrapperRef,
}: SubtotalInfoProps) => {
  const { t } = useTranslation();

  const renderGoToCheckoutdButton = () => {
    const disabled = company.hasAgeRestriction
      ? checkoutStore.hasAgeRestrictionError
      : undefined;

    const goToCheckout = (
      <button
        data-button="checkout"
        type="button"
        onClick={onNavigateToCheckout}
        className={classes([
          'button _primary _med',
          styles.subtotalInfo__button,
          styles.goToCheckoutButton,
          (isLoading || isWarehouseClosed || disabled) && '_disabled',
        ])}
        disabled={disabled}
      >
        {isLoading && <span className="spinner _white" />}
        {t('goToCheckout')}
      </button>
    );

    // TODO: hide temporaryly in cart - JS-7631
    // if (
    //   (!company.needVerification ||
    //     (userStore.isAuthorized &&
    //       userStore.personalData.kycStatus === KYCStatus.Verified)) &&
    //   cartStore.totalCartPrice.minimal_order_value_error?.length &&
    //   cartStore.totalCartPrice.minimal_order_value_error[0]
    // ) {
    //   return (
    //     <>
    //       <div
    //         onClick={onCheckout}
    //         className={classes([
    //           styles.goToCheckoutButton,
    //           'button _primary _med _disabled _center',
    //           styles.subtotalInfo__button,
    //         ])}
    //       >
    //         {t('errors:minCartError', {
    //           amount: formatPriceWithCurrency(
    //             cartStore.totalCartPrice.minimal_order_value_error[0]
    //               ?.minimalOrderValue / 100,
    //           ),
    //         })}
    //         <br />
    //         {t('errors:minCartErrorDetails', {
    //           amount: formatPriceWithCurrency(
    //             (cartStore.totalCartPrice.minimal_order_value_error[0]
    //               ?.minimalOrderValue -
    //               cartStore.totalCartPrice.minimal_order_value_error[0]
    //                 ?.orderPriceWithoutDelivery) /
    //               100,
    //           ),
    //         })}
    //       </div>
    //     </>
    //   );
    // }
    if (!company.needVerification) {
      return userStore.isAuthorized ? (
        goToCheckout
      ) : (
        <>
          <div
            onClick={onCheckout}
            className={classes([
              'button _primary _med',
              styles.subtotalInfo__button,
            ])}
          >
            {t('logInToCheckout')}
          </div>
        </>
      );
    }

    switch (userStore.personalData.kycStatus) {
      case KYCStatus.Verified:
        return goToCheckout;
      case KYCStatus.InProgress:
      case KYCStatus.ResubmissionRequested:
      case KYCStatus.Started: {
        const statusConfig = VERIFICATION[userStore.personalData.kycStatus];
        const isDisabled =
          userStore.personalData.kycStatus === KYCStatus.InProgress &&
          '_disabled';
        return (
          <>
            <div
              data-button="checkout"
              onClick={onCheckout}
              className={classes([
                `button _primary _med`,
                isDisabled,
                styles.subtotalInfo__button,
              ])}
            >
              {statusConfig.title}
            </div>
          </>
        );
      }
      default:
        return (
          <>
            <div
              data-button="checkout"
              onClick={onCheckout}
              className={classes([
                'button _primary _med',
                styles.subtotalInfo__button,
              ])}
            >
              {userStore.isAuthorized ? t('verifyId') : t('logInToCheckout')}
            </div>
          </>
        );
    }
  };

  return (
    <div className="subtotal-info" data-company={company.name}>
      <div
        className={styles.container}
        style={stickyWrapperStyles}
        ref={subtotalWrapperRef}
      >
        {cartStore.selectedItemsTotalCount > 0 ? (
          renderGoToCheckoutdButton()
        ) : (
          <>
            <button
              data-button="checkout"
              className={classes([
                'button _primary _disabled _med',
                styles.subtotalInfo__button,
                styles.goToCheckoutButton,
              ])}
            >
              {t('goToCheckout')}
            </button>
            <p className={styles.termsAndConditionText}>
              {t('selectProductsToContinue')}
            </p>
          </>
        )}
        <div className={styles.subtotalInfo}>
          {cartStore.selectedItemsTotalCount > 0 && (
            <div className={styles.subtotalWr}>
              <CartCostItems />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubtotalInfo;
